/**
 * Defines order types for sorting.
 */
export enum Order {
    ASC = 'asc',
    DESC = 'desc'
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/enums/order.enum.ts